/* ══════════════════════════════════════════════════════════════════════════
   DER EINLAUF FUER DIE ZWEI ERZAEHL-SEITEN                       22.08.2026
   ══════════════════════════════════════════════════════════════════════════
   ENZO: „bei Become a Creator und About us, da vielleicht wie bei Handfee das
   mal so ein bisschen umaendern. Da wollte ich so eine Animation haben."
   AUSDRUECKLICH NUR DORT. Am selben Tag hat er die Kachel-Animation auf
   Kategorie- und Produktseite zweimal abgelehnt: „das will ich auch fuer
   keinen Fall, sondern das soll so bleiben wie davor." Deshalb haengt hier
   alles an `.cr` und `.au` — den beiden Seitencontainern — und an nichts sonst.

   ── WAS handfee WIRKLICH MACHT (am 22.08. aus deren Quelltext gelesen) ──
   Keine Bibliothek, acht Zeilen:
     .hf-tk__reveal{opacity:0;transform:translateY(24px);
       transition:opacity .7s cubic-bezier(.22,1,.36,1),transform .7s …}
     .hf-tk__reveal.is-in{opacity:1;transform:translateY(0)}
   plus ein IntersectionObserver bei 15 % und `min(i,5) * 0.06s` Staffelung.

   ── WARUM HIER TROTZDEM KEIN ZWEITER BEOBACHTER ENTSTEHT ──
   `assets/theme.js` traegt bereits einen IntersectionObserver, einen
   MutationObserver fuer nachgeladene Teile und einen Anker-Beobachter.
   `assets/theme.css` traegt 29 Animationsarten sowie Dauern und Verzoegerungen
   in 50-ms-Schritten; `data-aos-duration="700"` ist dort 0,7 s, also exakt
   handfees Zeit. Es fehlten nur die Attribute, nicht die Maschine.

   ── WARUM DAS FRUEH GENUG LAEUFT ──
   `304-custom.js` und `theme.js` tragen beide `defer` und laufen deshalb in
   Dokumentreihenfolge, nachdem der Baum steht. `304-custom.js` steht VOR
   `theme.js` (snippets/social-meta.liquid:53) — wenn dessen Start
   `querySelectorAll('[data-aos]:not([data-aos-anchor]):not(.aos-animate)')`
   ausfuehrt, stehen unsere Attribute also schon da.

   ⛔ BEWUSST OHNE `data-aos-anchor`: der Anker-Beobachter sucht mit
   `anker.querySelectorAll(...)` nur NACHFAHREN, nie das Element selbst. Ein
   Anker auf sich selbst liesse das Element dauerhaft auf `opacity: 0` stehen.
   ⚠ Das Sicherheitsnetz dazu steht in `assets/304-custom.css`. Ohne das waere
   ein ausgefallener Beobachter keine fehlende Animation, sondern eine LEERE
   SEITE. */
(function(){
  /* ⛔ 22.08.2026, ZWEITER ANLAUF — VORHER LIEF JEDER SATZ EIN.
     Im ersten Anlauf standen hier auch `.cr-p`, `.cr-lead`, `.cr-list > li`,
     `.au-p`, `.au-spec` und so weiter: 45 bzw. 23 Elemente. ENZO danach:
     „du hast das jetzt bei jedem Text gemacht, das ist nur cool bei vielleicht
     mal einer Grafik und deswegen ist das so ein bisschen buggy."

     Er hat recht, und der Grund ist nicht Geschmack: wenn JEDER Absatz erst
     erscheinen muss, liest man nicht mehr, man wartet. Der Blick springt beim
     Scrollen staendig auf etwas, das noch nicht da ist. Bewegung wirkt nur,
     wenn sie selten ist.

     Jetzt laufen nur noch UEBERSCHRIFTEN und BILDER ein. Fliesstext, Listen,
     Kennzahlen und Knoepfe stehen sofort. Damit bleibt die Seite lesbar und
     die Animation setzt genau die Akzente, die handfee auch setzt. */
  /* ⛔ 22.08.2026, DRITTER ANLAUF — UEBERSCHRIFTEN RAUS.
     ENZO: „Die Scrollanimation sind jetzt Ueberschriften. Das ist irgendwie
     nicht gut, beziehungsweise ist dann halt auch ein bisschen redundant.
     Vielleicht bei den Grafiken oder sowas."

     Er hat recht, und der Grund ist benennbar: eine Ueberschrift ist ohnehin
     schon der Bruch im Lesefluss. Sie gross, fett und andersfarbig zu setzen
     UND sie zusaetzlich einlaufen zu lassen, sagt dieselbe Sache zweimal.
     Ein Bild dagegen hat keine solche Auszeichnung — dort ist Bewegung das
     einzige Mittel, das den Auftritt markiert.

     ── Was das je Seite bedeutet, gemessen am 22.08. ──
     `.au` (About Us) hat drei echte Grafiken UNTERHALB des ersten Bildschirms:
     zwei Bildbaender (`.au-band`, y 975 und y 2224) und die zwei Produktkarten
     (`.au-piece-media`, y 3854). Alle `position: relative`, also gefahrlos.
     `.cr` (Become a Creator) hat **genau ein** Bild, und das steht bei y 167,
     also ueber der Falz. Eine SCROLL-Animation hat dort nichts zu tun — sie
     waere eine Ladeanimation, und genau die hat Enzo auf den Kategorieseiten
     abgelehnt. Deshalb steht `.cr` hier bewusst LEER, statt etwas zu animieren,
     nur damit ueberall etwas passiert. */
  /* ⭐ 22.08.2026, VIERTER UND LETZTER STAND — DIE KACHELN SIND DAS ZIEL.
     ENZO: „Widgetkacheln wie bei Handfee, das ist cool, dann wird es auch
     nicht so viel Text." Damit hat der Einlauf endlich etwas, worauf er
     gehoert: Kacheln sind gleichrangige Elemente ohne eigene Auszeichnung,
     genau dort markiert Bewegung den Auftritt. Ueberschriften bleiben aussen
     vor (die sind schon durch Groesse und Farbe markiert), Fliesstext auch.

     11 Kacheln auf `/pages/creator` (4 Stufen, 3 Schritte, 4 Vorteile),
     3 auf `/pages/about-us` (Materialdaten), dazu die zwei Bildbaender.
     Gestaffelt je Elternelement, also faengt jede Gruppe bei 0 an. */
  var SEITEN = [
    { wurzel: '.cr', ziele: '.cr-list > li' },
    { wurzel: '.au', ziele: '.au-band, .au-spec' }
  ];

  SEITEN.forEach(function(seite){
    var wurzel = document.querySelector(seite.wurzel);
    if(!wurzel) return;

    var alle = [];
    seite.ziele.split(',').forEach(function(sel){
      sel = sel.trim();
      if(!sel) return;
      [].forEach.call(wurzel.querySelectorAll(sel), function(el){
        if(el.hasAttribute('data-aos')) return;   /* nichts Vorhandenes ueberschreiben */
        if(el.closest('form')) return;            /* das Bewerbungsformular bleibt sofort da */
        /* ⛔ Nie eine abgeloeste Ebene bewegen. `position:absolute/fixed` heisst
           in aller Regel: dieses Element DECKT etwas ab. Verschiebt man es,
           wird das Darunterliegende sichtbar — genau der Streifen, der am
           22.08. am Heldenbild von About Us aufblitzte. Diese Bremse steht hier
           dauerhaft, damit die Falle beim naechsten Selektor nicht wiederkommt. */
        var lage = getComputedStyle(el).position;
        if(lage === 'absolute' || lage === 'fixed') return;
        if(alle.indexOf(el) < 0) alle.push(el);
      });
    });
    if(!alle.length) return;

    /* Dokumentreihenfolge, sonst staffelt es in der Reihenfolge der
       Selektorenliste und nicht von oben nach unten. */
    alle.sort(function(a,b){
      return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    });

    /* Gestaffelt je Elternelement: so faengt jeder Abschnitt seine Kaskade neu
       an und die Seite laeuft nicht irgendwo unten mit 3 s Verzug weiter.
       Deckel bei 5 wie bei handfee, Schritte von 100 ms, weil das Theme nur
       Vielfache von 50 kennt. */
    var zaehler = new Map();
    alle.forEach(function(el){
      var p = el.parentElement;
      var i = zaehler.get(p) || 0;
      zaehler.set(p, i + 1);
      el.setAttribute('data-aos', 'fade-up');
      /* ⛔ 22.08.2026 — TEMPO NACHGEZOGEN.
         ENZO: „die Scrollanimationen gehen nicht so schnell wie man scrollt und
         dann kann man teilweise zwischendurch nicht weiter scrollen."

         Vorher 700 ms Dauer plus bis zu 500 ms Verzoegerung — im schlechtesten
         Fall 1,2 Sekunden, bis eine Kachel steht. Wer zuegig scrollt, ist da
         laengst vorbei und sieht nur noch halb erschienene Kaesten. Das ist
         kein Effekt mehr, das ist Nachhinken.

         Jetzt 400 ms und hoechstens 100 ms Verzoegerung, also maximal eine
         halbe Sekunde. Die Staffelung bleibt spuerbar (0/50/100), zieht die
         Gruppe aber nicht mehr auseinander.
         ⚠ Beide Werte muessen Vielfache von 50 sein — das Theme kennt nur
         solche Stufen (`[data-aos-duration="400"]`, `[data-aos-delay="50"]`).
         Ein krummer Wert greift schlicht nicht. */
      el.setAttribute('data-aos-duration', '400');
      var d = Math.min(i, 2) * 50;
      if(d) el.setAttribute('data-aos-delay', String(d));
    });
  });

  /* ── DAS NETZ: nur bei echtem Ausfall, nicht als Zeitschaltuhr ──
     `[data-aos^=fade]` steht auf `opacity: 0`, bis der Beobachter
     `aos-animate` vergibt. Faellt der aus, ist die Seite nicht „nicht
     animiert", sondern LEER. Bei einer Bewerbungsseite ist das teurer als
     jede fehlende Animation.

     ⚠ Ein reines CSS-Netz mit fester Verzoegerung waere falsch — es haette
     auch alles freigeschaltet, was noch 4000 px weiter unten liegt, und damit
     die Animation genau dort abgeschaltet, wo man sie sieht. Deshalb wird hier
     GEMESSEN statt gewartet: hat nach drei Sekunden kein einziges Element
     `aos-animate`, dann laeuft die Maschine nicht.

     ⚠ Gezaehlt wird nur SICHTBARE Zeit. In einem Hintergrund-Tab feuert kein
     IntersectionObserver und es laufen keine CSS-Animationen; ohne diese
     Bedingung wuerde das Netz dort jedes Mal ausloesen und die Animation
     wegwerfen, bevor der Nutzer die Seite ueberhaupt ansieht. Genau dieser
     Messfehler ist mir am 22.08. zweimal selbst passiert. */
  var SICHTBAR = '.cr [data-aos], .au [data-aos]';
  if(document.querySelector(SICHTBAR)){
    var sichtbareZeit = 0;
    var wache = setInterval(function(){
      if(document.visibilityState !== 'visible') return;
      sichtbareZeit += 250;
      if(sichtbareZeit < 3000) return;
      clearInterval(wache);
      if(document.querySelector('.cr [data-aos].aos-animate, .au [data-aos].aos-animate')) return;
      [].forEach.call(document.querySelectorAll(SICHTBAR), function(el){
        el.classList.add('aos-animate');
      });
    }, 250);
  }
})();

(function(){
  /* ===== Sold-Out Badge (PDP) ===== */
  function addBadge(){
    if(!document.querySelector('.price--sold-out')) return false;
    var media = document.querySelector('.product__slide.media--active')
             || document.querySelector('.product__media, .product-single__media, [data-product-media]')
             || document.querySelector('.product__slide');
    if(!media) return false;
    if(media.querySelector('.sold-out-badge-304')) return true;
    if(getComputedStyle(media).position === 'static'){ media.style.position = 'relative'; }
    var b = document.createElement('span'); b.className = 'sold-out-badge-304'; b.textContent = 'Sold Out';
    media.appendChild(b); return true;
  }

  /* ===== Store-Gesamtbewertung 4,7 -> 4,8 (NUR store-weit) ===== */
  function fixStoreRating(){
    var els = document.querySelectorAll('.wc-trust-header__text, .menu-trust-badge__text');
    for(var i=0;i<els.length;i++){ if(els[i].textContent.indexOf('4,7') !== -1){ els[i].textContent = els[i].textContent.replace('4,7','4,8'); } }
    var sp = document.querySelectorAll('span');
    for(var j=0;j<sp.length;j++){ if(sp[j].childElementCount===0 && sp[j].textContent.trim()==='4,7 STERNE'){ sp[j].textContent='4,8 STERNE'; } }
  }

  /* ===== Produktseite: Desktop-Review-Widget mit echten Daten fuellen ===== */
  function fixPdpRating(){
    if(!document.body || document.body.className.indexOf('template-product') === -1) return;
    var rating=null, cnt=null;
    var rows=document.querySelectorAll('.pdp-reviews-member-row, .custom-star-row, .rev-heading-row');
    for(var i=0;i<rows.length;i++){ var m=(rows[i].textContent||'').match(/(\d+[.,]\d+)\s*\|\s*(\d+)\s*Bewertung/i); if(m){ rating=m[1]; cnt=m[2]; break; } }
    if(!rating) return;
    var texts=document.querySelectorAll('.custom-rating-text');
    for(var j=0;j<texts.length;j++){ if(/[–-]/.test(texts[j].textContent||'')){ texts[j].textContent = rating.replace('.',',') + ' | ' + cnt + ' Bewertungen'; } }
  }

  /* ===== Produktseite Desktop: Sticky-Kaufen-Leiste ein-/ausblenden je nach
     Sichtbarkeit des oberen Kaufen-Buttons (IntersectionObserver). Nur >=990px. ===== */
  function initStickyCartBar(){
    if(!document.body || document.body.className.indexOf('template-product') === -1) return;
    if(window.innerWidth < 990) return;
    var bar=document.querySelector('.cart-bar'); if(!bar || bar.dataset.cb304) return;
    var mainAtc=null;
    var btns=document.querySelectorAll('button,[name="add"]');
    for(var i=0;i<btns.length;i++){ var b=btns[i]; if(b.closest('.cart-bar')) continue; if(/warenkorb/i.test(b.textContent||'')){ mainAtc=b; break; } }
    if(!mainAtc) return;
    bar.dataset.cb304='1';
    var io=new IntersectionObserver(function(es){ for(var k=0;k<es.length;k++){ if(es[k].isIntersecting) bar.classList.remove('cb-show-304'); else bar.classList.add('cb-show-304'); } },{threshold:0});
    io.observe(mainAtc);
  }

  function tick(){ addBadge(); fixStoreRating(); fixPdpRating(); initStickyCartBar(); }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', tick); } else { tick(); }
  window.addEventListener('load', tick);
  var tries = 0;
  var iv = setInterval(function(){ tries++; tick(); if(tries > 20) clearInterval(iv); }, 300);
  if(window.MutationObserver){
    var pending=false;
    function schedule(){ if(pending) return; pending=true; setTimeout(function(){ pending=false; fixStoreRating(); fixPdpRating(); initStickyCartBar(); }, 150); }
    function startObs(){ new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true}); }
    if(document.body){ startObs(); } else { document.addEventListener('DOMContentLoaded', startObs); }
  }
})();